import React from 'react';
import { LayerHost, mergeStyles } from '@fluentui/react';

import { snackbarBottomSpacing, snackbarZIndex } from './Snackbar';

export interface ISnackbarLayerHostProps {
  /**
   * The layer host id.
   * This value must match the `layerHostId` prop passed to
   * {@link Snackbar} so the notification is rendered inside the layer host.
   * Otherwise, the notification will be attached to the document body.
   */
  id: string;
  /**
   * Customize bottom position of snackbar notification. In the case of DialogCard,
   * it snackbar should be displayed above the footer buttons (not covering them).
   * @default snackbarBottomSpacing
   */
  bottomPosition?: number;
}

/**
 * An absolute-positioned {@link LayerHost} that will render a {@link Snackbar}
 * centered and at the bottom of its parent container.
 * IMPORTANT: Use this method for snackbars triggered within the context
 * of a modal, otherwise the dismiss or action click events will not propagate.
 *
 * @param props The layer host id
 * @returns {React.ReactElement} A {@link LayerHost} with absolute positioning.
 */
export const SnackbarLayerHost = (props: ISnackbarLayerHostProps) => {
  const { id, bottomPosition = snackbarBottomSpacing } = props;
  const layerClassName = mergeStyles({
    bottom: bottomPosition,
    left: '50%',
    position: 'absolute',
    transform: 'translateX(-50%)',
    zIndex: snackbarZIndex,
  });
  return <LayerHost id={id} className={layerClassName} />;
};
